/**
 * Common Queries
 *
 * Frequently used queries for common security exposures and risks.
 * These queries are useful across all customer environments.
 */

import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

import { QueryFolders } from './folders';

export const COMMON_QUERIES: SavedQuery[] = [
  {
    id: 'demonstrated-and-resolved-critical-risks',
    name: 'Demonstrated and Resolved Critical Risks',
    type: 'table',
    description:
      'Display all critical-severity risks, which have been either Demonstrated or Resolved.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: 'status',
            operator: 'ENDS WITH',
            value: 'C',
          },
          {
            field: '',
            operator: 'OR',
            value: [
              {
                field: 'status',
                operator: 'STARTS WITH',
                value: 'O',
              },
              {
                field: 'status',
                operator: 'STARTS WITH',
                value: 'R',
              },
            ],
          },
        ],
      },
      limit: 1000,
    },
  },
];
